import { QueryFeature } from '../../../../../config/queryClient';

enum QueryKey {
  Integration = 'Integration',
}

enum IntegrationType {
  Riskalyze = 'Riskalyze',
  Wealthbox = 'Wealthbox',
}

export const queryKeys = {
  integrations: () => [QueryFeature.Settings, QueryKey.Integration],
  riskalyze: (importPortfolios: string | null = null) => [
    QueryFeature.Settings,
    QueryKey.Integration,
    IntegrationType.Riskalyze,
    importPortfolios,
  ],
  Wealthbox: () => [QueryFeature.Settings, QueryKey.Integration, IntegrationType.Wealthbox],
};
